import { requestHandler } from '../../api';

export const getAvailableTemplates = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/mailing/templates`,
    dispatch,
  });
  if (response) return response.data;
};
